/**
 * Group Identity Column Definitions
 * Fixed column: group_id (always shown)
 * Optional standard: Members, Last Updated
 * Custom columns: from group custom_properties
 * Max 5 columns total (including the fixed group id).
 */

export const MAX_GROUP_COLUMNS = 5;

/** Always-on columns (not removable) */
export const FIXED_GROUP_COLUMNS = {
  group_id: {
    key: 'group_id',
    label: 'Group ID',
    field: 'groupId',
    fixed: true,
    required: true
  }
};

/** Built-in columns the user can show or hide (same slot pool as custom properties) */
export const OPTIONAL_STANDARD_GROUP_COLUMNS = {
  member_count: {
    key: 'member_count',
    label: 'Members',
    field: 'memberCount',
    fixed: false,
    required: false
  },
  last_updated_at: {
    key: 'last_updated_at',
    label: 'Last Updated',
    field: 'updatedAt',
    fixed: false,
    required: false,
    formatter: 'relativeTime'
  }
};

export const DEFAULT_GROUP_COLUMNS = {
  enabled: ['group_id', 'member_count', 'last_updated_at'],
  order: ['group_id', 'member_count', 'last_updated_at']
};

/** All predefined keys (fixed + optional standard), for filters / deduping */
export const ALL_PREDEFINED_GROUP_COLUMN_KEYS = new Set([
  ...Object.keys(FIXED_GROUP_COLUMNS),
  ...Object.keys(OPTIONAL_STANDARD_GROUP_COLUMNS)
]);

/**
 * Returns a merged column definition for a given key.
 */
export const getGroupColumnDefinition = (columnKey, customPropKeys = []) => {
  if (FIXED_GROUP_COLUMNS[columnKey]) return FIXED_GROUP_COLUMNS[columnKey];
  if (OPTIONAL_STANDARD_GROUP_COLUMNS[columnKey]) return OPTIONAL_STANDARD_GROUP_COLUMNS[columnKey];
  if (customPropKeys.includes(columnKey)) {
    return {
      key: columnKey,
      label: columnKey.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase()),
      field: columnKey,
      fixed: false,
      required: false,
      isCustom: true
    };
  }
  return null;
};
